module.exports = __webpack_public_path__ + "img/book1.b1e92038.png";